<template lang="html">
  <!-- @click event-listener is handed over to the whole item element as an intermediate station to the actual button-->
  <div class="todo-item" @click="$emit('show-modal')">
    <!-- the transition animates the element when set to done-->
    <transition mode="out-in">
      <TodoButton class="doneButton" key="doneButton" :icon="icon" label="" @click="handleDone" />
    </transition>
    <!-- in todo-text selected inputted information is shown -->
    <div class="todotext">
      <span :class="{ 'todo-done': isDone }">{{text}}</span>
      <!-- fontsize style binding shrinks extra information -->
      <span :class="{ 'todo-done': isDone }" :style="{ fontSize: `${fontSize}px`}">{{timeExpected}} h</span>
      <span :class="{ 'todo-done': isDone }" :style="{ fontSize: `${fontSize}px`}"> until {{doneUntil}}</span>
    </div>
    <!-- buttons to edit, delete and view -->
    <button class="show-todo-button" type="button" @click="showModal = true">
      <TodoIcon class="show-todo-icon" :icon="'visible'"/>
    </button>
    <button class="show-todo-button" type="button" @click="$emit('edit-todo', id)">
      <TodoIcon class="delet-icon-in-todo" :icon="'edit'"/>
    </button>
    <button class="show-todo-button" type="button" @click="$emit('delete', id)">
      <TodoIcon class="delet-icon-in-todo" :icon="'delet'"/>
    </button>
    <!-- modal that appears when the 'view' option is selected -->
    <!-- category-color changes the color of the modal depending on the category of the rhythm -->
    <TodoItemModal class="modal" :category-color="categoryColor" title="Add a rhythm" :visible="showModal" @close="showModal = false">

      <div class="upperinfo">
        <span class="title">{{text}}</span>
        <span class="date">{{date}}</span>
      </div>

      <h1>{{motiveText ? `${motiveText}` : 'every little step brings you closer to your long-term goals.'}}</h1>

      <!--span class="todotitle">{{text}}</span-->

      <div class="info">
        <div class="infoitems">
          <p class="inputedInfo">{{doneUntil}}</p>
          <p :style="{ fontSize: `${fontSize}px`}"> {{labeldone}} until </p>
        </div>
        <div class="infoitems">
          <p class="inputedInfo">{{expectedTime}} h</p>
          <p :style="{ fontSize: `${fontSize}px`}"> Expected </p>
        </div>
        <div class="infoitems">
          <p class="inputedInfo">{{timeNeeded}} h</p>
          <p :style="{ fontSize: `${fontSize}px`}"> needed </p>
        </div>
        <div class="infoitems">
          <p class="inputedInfo">{{projectName ? `${projectName}` : 'no'}}</p>
          <p :style="{ fontSize: `${fontSize}px`}"> project </p>
        </div>
        <div class="infoitems">
          <p class="inputedInfo">{{ category }}</p>
          <p :style="{ fontSize: `${fontSize}px`}"> list </p>
        </div>
      </div>
      <!-- @click event-listener is handed over to the button element as an intermediate station to the actual button inside the modal-->
      <TodoButton class="rightButton" :label="'edit'" :icon="'edit'" @click="$emit('edit-todo', id)"></TodoButton>
    </TodoItemModal>

  </div>
</template>

<script>
import TodoButton from '@/components/TodoButton.vue';
import TodoIcon from '@/components/TodoIcon.vue';
import TodoItemModal from '@/components/TodoItemModal.vue';
// import format function of date-fns, that was installed before with npm
import { format } from 'date-fns';
import db from '@/db.js';

export default {
  components: {
    TodoButton,
    TodoIcon,
    TodoItemModal,
  },
  async created() {
    // set ptoject name by project-ID
    this.setProjectName(this.project);
    this.setMotiveText(this.motive);
  },
  data() {
    return {
      fontSize: 10,
      projectName: '',
      motiveText: '',
      showModal: false,
      showEditModal: false,
      todoBeingEdited: null,
      activeView: null,
      newTodo: '',
      newTodoProject: '',
      newTodoMotive: '',
      options: ['important', 'habits', 'not-to-do'],
      importantcolor: 'importantcolor',
      nottodocolor: 'nottodocolor',
      habitscolor: 'habitscolor',
      settingscolor: 'settingscolor',
    };
  },
  computed: {
    // set dueDate input to today
    doneUntil() {
      return format(new Date(this.dueDate), 'dd. MM. yyyy');
    },
    // it would have been possible to write done === true in the template, but it's less clean
    isDone() {
      if (this.done) return true;
      return false;
    },
    icon() {
      if (this.done) return 'doneBox';
      return 'checkbox';
    },
    // return today's date
    // format date to a special string, dd MMM and yyyy are like variables for the date
    date() {
      return format(new Date(this.createdAt), 'dd. MMM yyyy');
    },
    // exchanges label depending on done/undone
    labeldone() {
      if (this.done) return 'already done';
      return 'to be done';
    },
    // displays expected time
    expectedTime() {
      if (this.timeExpected) return this.timeExpected;
      return this.timeExpected;
    },
    // changes the color of the modal depending on the category of the rhythm
    categoryColor() {
      if (this.category === 'important') return this.importantcolor;
      if (this.category === 'habits') return this.habitscolor;
      if (this.category === 'not-to-do') return this.nottodocolor;
      return this.settingscolor;
    },
  },
  methods: {
    // @click event-listener is handed over to the doneButton element to set the todo done
    handleDone() {
      this.$emit('done');
    },
    async setProjectName(id) {
      if (id) {
        try {
          // find project with ID "id"
          const project = await db.projects.get(id);
          // return it's name
          this.projectName = project.name;
        } catch (err) {
          // a toast message, when something went wrong
          this.$store.commit('addToast', { message: `Sorry. Your rhyrhms could not be imported: ${err.message}` });
        }
      }
    },
    async setMotiveText(id) {
      if (id) {
        try {
          const motive = await db.motives.get(id);
          this.motiveText = motive.text;
        } catch (err) {
          this.$store.commit('addToast', { message: `Sorry. your motivation text could not be added: ${err.message}` });
        }
      }
    },
    // closes modal
    closeTodoModal() {
      this.todoBeingEdited = null;
      this.showTodoModal = false;
    },
    // edits todo when an id could be found -> makes sure that it's clear which one is edited
    handleEdit(id) {
      this.todoBeingEdited = this.todos.find((todo) => todo.id === id); // search for todo with the id from the loaded todos and save it in data
      this.showEditModal = true;
    },
    async handleSave() {
      const {
        text, hoursTotal, hoursWorked, projectName, motiveText, dueDate, category,
      } = this;
      if (!text) return;
      if (!this.todo) {
        this.$emit('add', {
          text, hoursTotal, hoursWorked, projectName, motiveText, category,
        });
        this.text = '';
        this.hoursTotal = '';
        this.hoursWorked = '';
        this.projectName = '';
        this.motiveText = '';
        this.dueDate = '';
        this.category = '';
        this.$store.commit('addToast', { message: 'Your rhythm has been added.' });
      } else {
        this.$emit('update', {
          text, hoursTotal, hoursWorked, projectName, motiveText, dueDate, category,
        });
        this.$store.commit('addToast', { message: 'Your rhythm has been edited.' });
      }
    },
    async saveTodo() {
      const {
        newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate, category,
      } = this;
      if (!newTodo) return;
      if (!this.todo) {
        this.$emit('add', {
          newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate, category,
        });
        this.newTodo = '';
        this.newTodoProject = '';
        this.newTodoMotive = '';
        this.timeExpected = '';
        this.timeNeeded = '';
        this.dueDate = '';
        this.category = '';
      } else {
        this.$emit('update', {
          newTodo, newTodoMotive, newTodoProject, timeNeeded, timeExpected, dueDate, category,
        });
      }
    },
    async setTodoData() {
      if (!this.todo) return;
      const {
        newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate, category,
      } = this.todo;
      if (newTodoProject) {
        const { name } = await this.$store.dispatch('loadProjects', newTodoProject);
        this.newTodoProject = name;
      }
      if (newTodoMotive) {
        const { text } = await this.$store.dispatch('loadMotives', newTodoMotive);
        this.newTodoMotive = text;
      }
      this.newTodo = newTodo;
      this.newTodoProject = newTodoProject;
      this.newTodoMotive = newTodoMotive;
      this.timeExpected = timeExpected;
      this.timeNeeded = timeNeeded;
      this.dueDate = dueDate;
      this.category = category;
    },
  },
  watch: {
    // when a prop of a project or motive changes get the new project name and motive text
    todo(newValue) {
      if (newValue) this.setTodoData();
      else {
        this.newTodo = '';
        this.newTodoMotive = '';
        this.newTodoProject = '';
        this.timeExpected = '';
        this.timeNeeded = '';
        this.dueDate = '';
        this.category = '';
      }
    },
    async project(newVal) {
      this.setProjectName(newVal);
    },
    async motive(newVal) {
      this.setMotiveText(newVal);
    },
  },
  props: {
    timeExpected: Number,
    timeNeeded: Number,
    createdAt: {
      type: Number,
      default: 0,
    },
    dueDate: {
      type: Number,
      default: 0, // if dueDate time travels to 1st january 1970 that's why
    },
    category: String,
    id: Number,
    done: Boolean,
    project: Number,
    motive: Number,
    text: {
      type: String,
      default: 'Empty Todo',
    },
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.todo-item
  display: flex
  align-items: center
  padding: 8px
  border-radius: 0px
  height: 45px
  padding-right: 30px
  border-top: 1px
  border-color: black
  font-family: futura-pt, sans-serif
  font-weight: 400;
  font-style: normal
  text-transform: uppercase;
  border-top: solid 1px black
  color: inherit
  // prevents text to jump into the next line, cut's it when it's too long and set's points instead
  .todotext
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  .show-todo-button
    opacity: 0

  .delet-icon-in-todo
    opacity: 0

  &:focus
    transition: 100ms ease
    color: inherit
    background-color: transparent
    border:none
    outline: none

  &:active
    color: inherit
    background-color: transparent
    outline: none

  &:hover
    transition: 100ms ease
    transition: background-color 500ms ease
    color: white
    background-color: black
    outline: none

    .delet-icon-in-todo
      opacity: 1
      transition: 100ms ease

    .show-todo-button
      opacity: 1
      transition: 100ms ease

    .icon
      color: white
      transition: 100ms ease

    .button
      color: white
      transition: 100ms ease

  span
    width: 100%
    margin-right: 5px

    &.todo-done
      text-decoration: line-through

  .doneButton
    margin-left: 30px
    margin-right: 10px
    padding-top: 12px
    display: inline
    background-color: transparent

    @media $tablet
      margin-left: 185px

    &:focus
      color: inherit
      background-color: transparent
      border:none
      outline: none
      color: white

    &:active
      color: inherit
      background-color: transparent
      outline: none
      color: white

    &:hover
      color: black
      background-color: transparent
      outline: none
      color: white

    &.v-enter-active,
    &.v-leave-active
      transition: opacity 700ms ease

      &.v-enter,
      &.v-leave-to
        opacity: 0

  .show-todo-button
    background-color: transparent
    outline: none
    border: none

  .delet-button
    color: white
    background-color:transparent
    outline: none
    border: none
    margin-left: 25px
    margin-top: 30px
    &:active
      color: white
      background-color:transparent

    &:hover
      color: white
      background-color:transparent

    &:focus
      color: white
      background-color:transparent

  .delet-icon-in-todo
    margin-top: 5px
    width: 15px
    height: 15px
    &:hover
      transition: 200ms ease
      width: 18px
      height: 18px

  .show-todo-icon
    margin-top: 10px
    margin-left: 10px
    margin-right: 0px
    float: right
    right: 0
    display: inline
    background-color: transparent
    color: black
    opacity: 1
    width: 15px
    height: 15px

    &:focus
      color: black
      background-color: transparent
      border:none
      outline: none
      color: white

    &:active
      color: black
      background-color: transparent
      outline: none
      color: white

    &:hover
      color: black
      background-color: transparent
      outline: none
      color: white
      transition: 200ms ease
      width: 18px
      height: 18px

    &.v-enter-active,
    &.v-leave-active
      transition: opacity 700ms ease

      &.v-enter,
      &.v-leave-to
        opacity: 0
        color: black

.button
  font-size: 16px

// modal
.modal
  h1
    font-family: operetta-8, serif
    font-weight: 700
    font-style: normal
    text-transform: lowercase
    text-align: left
    font-size: 30
    margin-top: 30px
    padding-top: 0px !important
    padding-bottom: 50px !important
    margin-bottom: 0px !important

    @media $desktop
      padding-left: 40px !important
      width: 80%

  p
    font-family: futura-pt, sans-serif
    font-weight: 400;
    font-style: normal
    text-transform: uppercase
    font-size: 16px

  span
    font-family: futura-pt, sans-serif
    font-weight: 400;
    font-style: normal
    text-transform: uppercase
    font-size: 16px

  .todotitle
    padding-right: 40px
    padding-left: 40px

  .upperinfo
    display: inline-flex
    width: 100% !important
    align-items: center
    padding-left: 40px
    padding-right: 40px
    padding-top: 16px

    .date
      float: right
      margin-right: auto
      order: 2
      margin-right: 0px !important
      text-align: right !important
      padding-right: 60px

    .title
      left: 0
      margin-right: 40px
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .v-enter, .v-leave
        transition: opacity 0

      .v-enter-to, .v-leave-to
        opacity: 1

  .info
    margin-top: 5px
    padding-top: 5px
    border-bottom: solid black 0.5px

    .infoitems
      height:40px
      padding-left: 40px
      display: flex
      align-items: center
      border-top: solid black 0.5px

      p
        padding-right: 10px
        margin-bottom: 0px !important
        margin-top: 0px !important

    div
      padding-bottom: 6px
      margin: 0 !important
      padding-top: 10px
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      display: flex

  .rightButton
    position: absolute
    right:0
    margin-right: 20px
    bottom: 40px
    display: inline-flex
    align-items: center
    color: black !important
    padding: 10px;
    padding-right: 30px
    padding-left: 5px
    border-radius: 2px
    color: black
    border-top: solid 0.5px black
    border-bottom: solid 0.5px black

    // the last way out if i need to change a property that's already defined in another component
    >>> .icon
        width: 15px;
        height: 15px;
        color: black !important;
    &:focus
      background-color: transparent
      color: black
      border:transparent
      outline: none
      border: solid 0.5px black

    &:active
      color: black
      background-color: transparent
      border:transparent
      border: solid 0.5px black

    &:hover
      transition: 200ms ease
      color: black
      background-color: transparent
      border:transparent
      border: solid 0.5px black

</style>
